import { formatCalendarDate } from "@/Utils/helper";

import check from "../../../../../../public/BP_resources/images/icon/checkmark.svg";
import activeEmail from "../../../../../../public/BP_resources/images/icon/emailactive.svg";
import mail from "../../../../../../public/BP_resources/images/icon/mailbox.svg";

export const PANEL_CONFIGS = {
  clientName: {
    type: "simple",
    basePath: "client",
    fields: [
      {
        label: "First",
        path: "first_name",
        labelBold: true,
      },
      {
        label: "Middle",
        path: "middle_name",
        labelBold: true,
        transform: (val) => (val ? val.charAt(0).toUpperCase() + val.slice(1) : ""),
      },
      {
        label: "Last",
        path: "last_name",
        labelBold: true,
      },
    ],
  },

  clientPhoneNumbers: {
    type: "phoneArray",
    contacts: ["contact_1", "contact_2", "contact_3"],
    basePath: "client",
    primaryPath: "client.primary_phone.id",
    primaryIcon: check,
    placeholder: "(###) ###-####",
  },

  clientEmail: {
    type: "emailArray",
    contacts: ["contact_1", "contact_2", "contact_3"],
    basePath: "client",
    primaryPath: "client.primary_email.id",
    primaryIcon: activeEmail,
    placeholder: "email@xyz.com",
    truncate: 25,
  },

  clientAddress1: {
    type: "address",
    basePath: "client",
    contactPath: "contact_1",
    mailingPath: "client.mailing_contact.id",
    mailingIcon: mail,
    fields: [
      { type: "name", firstNamePath: "client.first_name", lastNamePath: "client.last_name" },
      { type: "address", address1Path: "address1", address2Path: "address2" },
      { type: "cityStateZip", cityPath: "city", statePath: "state", zipPath: "zip" },
    ],
  },

  clientAddress2: {
    type: "address",
    basePath: "client",
    contactPath: "contact_2",
    mailingPath: "client.mailing_contact.id",
    mailingIcon: mail,
    fields: [
      { type: "name", firstNamePath: "client.first_name", lastNamePath: "client.last_name" },
      { type: "address", address1Path: "address1", address2Path: "address2" },
      { type: "cityStateZip", cityPath: "city", statePath: "state", zipPath: "zip" },
    ],
  },

  clientSSNData: {
    type: "simple",
    basePath: "client",
    fields: [
      {
        label: "Title",
        path: "ClientTitleID.name",
        placeholder: "Mr./Mrs./Ms.",
        labelBold: true,
      },
      {
        label: "Birthday",
        path: "birthday",
        placeholder: "DD/MM/YYYY",
        labelBold: true,
        transform: (val) => (val ? formatCalendarDate(val) : null),
      },
      {
        label: "License",
        path: "driver_license_number",
        placeholder: "X############",
        labelBold: true,
        transform: (val, _formatDate, client) =>
          client?.has_driver_license === false ? (
            <span style={{ color: "var(--primary-25)" }}>No DL Number</span>
          ) : (
            val
          ),
      },
    ],
  },

  clientSpouseContact: {
    type: "address",
    basePath: "client.spouse",
    contactPath: "contact",
    unavailableWhen: "client.has_marital_status",
    unavailableText: "N/A — No Marital Status",
    fields: [
      {
        type: "name",
        firstNamePath: "client.spouse.first_name",
        lastNamePath: "client.spouse.last_name",
      },
      { type: "address", address1Path: "address1", address2Path: "address2" },
      { type: "cityStateZip", cityPath: "city", statePath: "state", zipPath: "zip" },
    ],
  },

  clientSpouseInfo: {
    type: "simple",
    basePath: "client.spouse",
    unavailableWhen: "client.has_marital_status",
    unavailableText: "N/A — No Marital Status",
    fields: [
      {
        label: "Marital Status",
        path: "marital_status",
        labelBold: true,
      },
      {
        label: "Discuss",
        path: "discussCase",
        labelBold: true,
        transform: (val) => (val ? <span className="color-green">Yes</span> : null),
        placeholder: "Not Clear",
      },
      {
        label: "Phone",
        path: "contact.phone_number",
        placeholder: "(###) ###-####",
        labelBold: true,
      },
    ],
  },

  clientEmergencyContact: {
    type: "address",
    basePath: "client.emergency_contact",
    contactPath: "contact",
    unavailableWhen: "client.has_emergency_contact",
    unavailableText: "N/A — No Emergency Contact",
    fields: [
      {
        type: "name",
        firstNamePath: "client.emergency_contact.first_name",
        lastNamePath: "client.emergency_contact.last_name",
      },
      { type: "address", address1Path: "address1", address2Path: "address2" },
      { type: "cityStateZip", cityPath: "city", statePath: "state", zipPath: "zip" },
    ],
  },

  clientEmergencyInfo: {
    type: "simple",
    basePath: "client.emergency_contact",
    unavailableWhen: "client.has_emergency_contact",
    unavailableText: "N/A — No Emergency Contact",
    fields: [
      {
        label: "Relationship",
        path: "relationship",
        labelBold: true,
      },
      {
        label: "Discuss",
        path: "discussCase",
        labelBold: true,
        transform: (val) => (val ? <span className="color-green">Yes</span> : null),
        placeholder: "Not Clear",
      },
      {
        label: "Phone",
        path: "contact.phone_number",
        placeholder: "(###) ###-####",
        labelBold: true,
      },
    ],
  },
};
